import React, { useEffect, useRef, useState } from "react";
import { Button } from "./ui/button";
import { Card } from "./ui/card";
import { Badge } from "./ui/badge";

const reviews = [
  {
    id: "review-1",
    name: "Pilar Lerena",
    rating: 5,
    text:
      "El trabajo de RG es excelente. Me arregló la computadora y la impresora, dejándolas en perfecto estado. Siempre responde al instante cada vez que necesito su ayuda y soluciona todo de manera rápida y eficaz. Además, hay cosas que me hizo a distancia, lo cual es súper práctico y cómodo. Lo recomiendo 100%."
  },
  {
    id: "review-2",
    name: "Francisco Lavoz",
    rating: 5,
    text:
      "Soy de La Plata y me solucionó problemas de Windows, drivers y programas. 10/10 todo."
  },
  {
    id: "review-3",
    name: "Tobías Litwin",
    rating: 5,
    text:
      "Mil puntos, hace un tiempo llevé mi PC de escritorio y la dejó impecable. Ahora le llevé mi notebook que hacía más ruido que un dron y quedó como nueva. Excelente laburo y buen precio, muy recomendable."
  },
  {
    id: "review-4",
    name: "Matías",
    rating: 5,
    text:
      "Antes prendía la compu, ponía el agua para los mates, me lavaba los dientes, me cambiaba, armaba el mate y volvía a la PC, y todavía tenía que esperar para poder usarla de lo lenta que estaba... Desde que le llevé la PC a estos muchachos no puedo ni pestañear: ¡ya está lista para que la use! Recomiendo mucho la limpieza total para rendimiento óptimo. ¡Me cambió la vida! Gracias RG Servicio Técnico, tomé mis 5 estrellas, buen hombre."
  },
  {
    id: "review-5",
    name: "Francisco Fernandez",
    rating: 5,
    text:
      "Siempre que acudí para mantenimiento/actualización de hardware y software recibí un excelente servicio, muy recomendable."
  },
  {
    id: "review-6",
    name: "Valentina Agustinelli",
    rating: 5,
    text:
      "Excelente servicio. Realicé un mantenimiento de limpieza a mi PC y quedó impecable."
  },
  {
    id: "review-7",
    name: "Tomás Vinella",
    rating: 5,
    text:
      "Vino hasta mi domicilio, y en un rato me limpió todos los componentes y me cambió la pasta térmica. Un lujo, y la atención diez puntos."
  },
  {
    id: "review-8",
    name: "Gian Lucas Di Leo",
    rating: 5,
    text:
      "De 10, estuve meses queriendo arreglar mi notebook y ellos fueron los únicos que me lo resolvieron. Muy profesionales."
  },
  {
    id: "review-9",
    name: "Arístides Oberti",
    rating: 5,
    text:
      "Excelente atención, me dejó el celu y la compu como nueva; súper recomendable."
  },
  {
    id: "review-10",
    name: "Lucas Martinez",
    rating: 5,
    text:
      "Realizaron muy bien la limpieza y el arreglo de Play 4, y muy rápido."
  },
  {
    id: "review-11",
    name: "Nico Sesarego",
    rating: 5,
    text:
      "Increíblemente rápido, detallista y eficaz. Resolvió todos los problemas de mi PC que otros técnicos no pudieron. 10/10."
  },
  {
    id: "review-12",
    name: "Franco Scarpelli",
    rating: 5,
    text: "¡Excelente servicio! ¡Recomendadísimo!"
  }
];

const googleReviewsUrl =
  "https://www.google.com/maps/place/RG+Servicio+T%C3%A9cnico/@-34.857257,-61.5251968,14z/data=!4m6!3m5!1s0x95c743345c1680f7:0x1a9da2c60de1e6fc!8m2!3d-34.8538401!4d-61.5355996!16s%2Fg%2F11xvf4pgzx?entry=ttu&g_ep=EgoyMDI2MDMxMS4wIKXMDSoASAFQAw%3D%3D";

const ReviewsSection = () => {
  const trackRef = useRef(null);
  const isPaused = false;
  const [expandedMap, setExpandedMap] = useState({});
  const extendedReviews = [...reviews, ...reviews];
  const loopWidthRef = useRef(0);
  const manualPauseRef = useRef(0);
  const isDraggingRef = useRef(false);
  const dragStartXRef = useRef(0);
  const dragStartScrollRef = useRef(0);

  const handleArrow = (direction) => {
    const el = trackRef.current;
    if (!el) return;
    const card = el.querySelector('[data-review-card="true"]');
    const strip = el.querySelector('[data-review-strip="true"]');
    let gap = 0;
    if (strip) {
      const styles = window.getComputedStyle(strip);
      gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
    }
    const base = card ? card.offsetWidth + gap : Math.min(el.clientWidth * 0.85, 420);
    const amount = base * direction;
    manualPauseRef.current = Date.now() + 900;
    el.scrollBy({ left: amount, behavior: "smooth" });
  };

  const handlePointerDown = (event) => {
    const el = trackRef.current;
    if (!el) return;
    isDraggingRef.current = true;
    dragStartXRef.current = event.clientX;
    dragStartScrollRef.current = el.scrollLeft;
    manualPauseRef.current = Date.now() + 900;
    el.setPointerCapture?.(event.pointerId);
  };

  const handlePointerMove = (event) => {
    if (!isDraggingRef.current) return;
    const el = trackRef.current;
    if (!el) return;
    const delta = event.clientX - dragStartXRef.current;
    el.scrollLeft = dragStartScrollRef.current - delta;
  };

  const handlePointerUp = (event) => {
    if (!isDraggingRef.current) return;
    isDraggingRef.current = false;
    const el = trackRef.current;
    if (!el) return;
    el.releasePointerCapture?.(event.pointerId);
  };

  useEffect(() => {
    const el = trackRef.current;
    if (!el) return;

    el.scrollLeft = 0;
    const speed = 0.35; // px per tick
    const tick = () => {
      const maxScroll = Math.max(0, el.scrollWidth - el.clientWidth);
      loopWidthRef.current = maxScroll;
      if (
        maxScroll > 0 &&
        !isPaused &&
        Date.now() >= manualPauseRef.current &&
        !isDraggingRef.current
      ) {
        let next = el.scrollLeft + speed;
        if (next >= maxScroll) next = 0;
        el.scrollLeft = next;
      }
    };

    const id = window.setInterval(tick, 16);
    return () => window.clearInterval(id);
  }, [isPaused]);

  useEffect(() => {
    const el = trackRef.current;
    if (!el) return;

    const updateLoopWidth = () => {
      const child = el.querySelector('[data-review-strip="true"]');
      if (!child) return;
      const maxScroll = child.scrollWidth - el.clientWidth;
      loopWidthRef.current = Math.max(0, maxScroll);
    };

    updateLoopWidth();

    const observer = new ResizeObserver(updateLoopWidth);
    observer.observe(el);

    const fontsReady = document?.fonts?.ready;
    if (fontsReady) {
      fontsReady.then(updateLoopWidth).catch(() => {});
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="resenas" className="py-20 bg-background text-foreground">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex text-center justify-center items-center gap-4 flex-col mb-12">
          <Badge>Reseñas</Badge>
          <div className="flex gap-2 flex-col">
            <h2 className="text-3xl md:text-5xl tracking-tighter max-w-3xl text-center font-regular">
              Opiniones reales de quienes nos eligen
            </h2>
            <p className="text-lg leading-relaxed tracking-tight text-muted-foreground max-w-3xl text-center">
              Testimonios destacados de Google para que conozcas la experiencia de nuestros clientes.
            </p>
          </div>
        </div>

        <div className="relative">
          <div className="hidden md:block">
            <button
              type="button"
              onClick={() => handleArrow(-1)}
              className="absolute -left-20 lg:-left-24 top-1/2 -translate-y-1/2 z-10 h-10 w-10 rounded-full bg-card border border-border shadow-lg flex items-center justify-center text-foreground hover:scale-105 transition-transform text-lg leading-none"
              aria-label="Deslizar reseñas a la izquierda"
            >
              ‹
            </button>
            <button
              type="button"
              onClick={() => handleArrow(1)}
              className="absolute -right-20 lg:-right-24 top-1/2 -translate-y-1/2 z-10 h-10 w-10 rounded-full bg-card border border-border shadow-lg flex items-center justify-center text-foreground hover:scale-105 transition-transform text-lg leading-none"
              aria-label="Deslizar reseñas a la derecha"
            >
              ›
            </button>
          </div>
          <div
            ref={trackRef}
            className="overflow-x-scroll overflow-y-visible pt-2 -mt-2 pb-8 -mx-1 px-1 no-scrollbar select-none cursor-grab active:cursor-grabbing"
            style={{ scrollBehavior: "auto" }}
            onPointerDown={handlePointerDown}
            onPointerMove={handlePointerMove}
            onPointerUp={handlePointerUp}
            onPointerLeave={handlePointerUp}
          >
            <div data-review-strip="true" className="flex flex-nowrap gap-4 md:gap-6 w-max">
              {extendedReviews.map((review, index) => (
                <Card
                  key={`${review.id}-${index}`}
                  data-review-card="true"
                  className="group rounded-3xl border border-border bg-card p-6 shadow-none w-[260px] md:w-[320px] lg:w-[360px] flex-shrink-0 transition-transform duration-300 hover:-translate-y-1"
                >
                <div className="flex items-center gap-3">
                  <div className="h-12 w-12 rounded-full bg-secondary text-foreground flex items-center justify-center font-semibold">
                    {review.name.charAt(0)}
                  </div>
                  <div>
                    <p className="text-base font-semibold text-foreground">
                      {review.name}
                    </p>
                    <div className="flex items-center gap-1 text-amber-400">
                      {Array.from({ length: 5 }).map((_, index) => (
                        <span key={index} className="text-sm">
                          {index < review.rating ? "\u2605" : "\u2606"}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="mt-4 text-sm text-muted-foreground leading-6 text-left break-words hyphens-none tracking-normal">
                  {(() => {
                    const words = review.text.split(" ");
                    const isLong = words.length > 26;
                    const isExpanded = !!expandedMap[index];
                    if (!isLong) return review.text;
                    const preview = words.slice(0, 26).join(" ");
                    return isExpanded ? review.text : `${preview}…`;
                  })()}
                </p>
                {review.text.split(" ").length > 26 && (
                  <button
                    type="button"
                    className="mt-3 text-sm font-semibold text-primary hover:text-primary/80"
                    onClick={() =>
                      setExpandedMap((prev) => ({
                        ...prev,
                        [index]: !prev[index]
                      }))
                    }
                  >
                    {expandedMap[index] ? "Ver menos" : "Ver más"}
                  </button>
                )}
                </Card>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex justify-center">
          <Button
            asChild
            className="plan-button px-6 py-3 text-base font-semibold shadow-lg bg-primary text-primary-foreground hover:bg-primary/90"
          >
            <a href={googleReviewsUrl} target="_blank" rel="noreferrer">
              Ver todas las reseñas en Google
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;





